'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.isSweepstakesQuery = void 0;
var tslib_1 = require("tslib");
var config_query_1 = require("./config-query");
function isSweepstakesQuery() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, config_query_1.configQuery('sweepstakes')];
                case 1: return [2 /*return*/, !!(_a.sent())];
            }
        });
    });
}
exports.isSweepstakesQuery = isSweepstakesQuery;
